export default "__VITE_ASSET__Bxu5zfJG__"